import { render, staticRenderFns } from "./footer-menu-item.vue?vue&type=template&id=e5d7a820&scoped=true&"
import script from "./footer-menu-item.vue?vue&type=script&lang=js&"
export * from "./footer-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./footer-menu-item.vue?vue&type=style&index=0&id=e5d7a820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d7a820",
  null
  
)

export default component.exports